import 'css-chunksrc/client/common/elementAttachments/documentCard/thumbnail/styles.scss';export default {
  "thumbnail": "_thumbnail_gohw9_1",
  "icon": "_icon_gohw9_7"
};